// GAVION commissions: the company page « Abonnement » and the deal page « Étapes de la vente ».
export const commissionsClientFr = {
  subscription: {
    title: "Abonnement",
    none: "Aucun abonnement.",
    create: "Créer l'abonnement",
    new_subscription: "Nouvel abonnement",
    scheduled: "À partir de %{month} : %{plan}",
    change: "Changer le forfait",
    cancel: "Résilier",
    add_exception: "Ajouter une exception",
    add_fee: "Ajouter des frais",
    plan: "Forfait",
    billing: "Facturation",
    addons: "Options",
    no_addons: "Aucune option",
    services: "Services récurrents",
    no_services: "Aucun service récurrent",
    add_service: "Ajouter un service récurrent",
    remove_service: "Retirer le service récurrent %{n}",
    mrr: "MRR ce mois-ci",
    first_paid_month: "Premier mois payé",
    month_number: "Mois de l'abonnement",
    cancelled: "Résilié — dernier mois facturé : %{month}",
    periods: "Historique des forfaits",
    exceptions: "Exceptions",
    fees: "Frais uniques (hors commission)",
    none_yet: "Aucun.",
    from_month: "à partir de %{month}",
    annual_paid: "%{amount} payés pour l'année",
    delete: "Supprimer",
    delete_exception: "Supprimer l'exception de %{month}",
    delete_fee: "Supprimer les frais de %{month}",
    saved: "Abonnement enregistré",
    confirm_cancel: "Résilier cet abonnement après %{month} ?",
    suggestion: "Suggestion : %{amount} (rabais annuel %{pct} %)",
    stripe_badge: "Stripe",
    stripe_link: "Voir dans Stripe",
    stripe_managed:
      "Géré par Stripe : le forfait, le prix, la facturation, les dates et la résiliation se changent dans Stripe (la synchronisation les applique ici).",
    submit_create: "Créer",
    submit_change: "Enregistrer",
    close: "Annuler",
    origin: {
      legend:
        "Ce client avait un abonnement résilié (dernier mois facturé : %{month}). Ce nouvel abonnement est :",
      resume: "Reprise",
      resume_hint:
        "Le client est revenu de lui-même : le compte des mois continue celui de l'ancien abonnement (le taux du plan ne repart pas au mois 1) et les commissions vont aux personnes de l'opportunité d'origine.",
      new: "Nouvelle vente",
      new_hint:
        "Un représentant l'a ramené : une nouvelle opportunité, avec ses propres étapes de la vente ; mois 1 pour les nouvelles personnes.",
    },
    fields: {
      deal: "Opportunité",
      package: "Forfait",
      billing: "Facturation",
      first_month: "Premier mois payé",
      from_month: "À partir du mois",
      addon_qty: "%{name} (quantité)",
      services:
        "Services récurrents (intégrations, nouveaux produits : dans la base de commission)",
      service_name: "Service récurrent %{n} : nom",
      service_amount: "Service récurrent %{n} : montant ($ par mois)",
      annual_amount: "Montant annuel payé ($)",
      note: "Note",
      month: "Mois",
      kind: "Exception",
      amount_collected: "Montant perçu ($)",
      amount: "Montant ($)",
      ended_month: "Dernier mois facturé",
    },
    errors: {
      required: "Champ requis.",
      month: "Choisissez un mois.",
      amount: "Montant invalide.",
      qty: "Quantité : un nombre entier.",
      service:
        "Chaque service récurrent : un nom et un montant mensuel entre 0 et 100 000.",
      long: "Texte trop long.",
      new_deal:
        "Cette opportunité a déjà un abonnement : une « Nouvelle vente » demande une nouvelle opportunité.",
    },
  },
  sale_steps: {
    title: "Étapes de la vente",
    setter: "Setter (rendez-vous)",
    demo_by: "Démo par",
    demo_by_default: "%{name} (par défaut : le Closer)",
    demo_by_default_setter: "%{name} (par défaut : le setter, sans Closer)",
    closer: "Closer (négociation et signature)",
    source: "Source de la vente",
    appointment_at: "Rendez-vous pris le",
    demo_held_at: "Démo tenue le",
    override: "Dérogation",
    override_value: "part %{pct} %",
    override_setter_value: "setter %{pct} %",
    undecided:
      "À décider : le contrat ne fixe pas ce partage (art. 4.5.6). Entrez la part convenue du Closer (et du setter s'il a obtenu le rendez-vous et fait la démo) dans la dérogation ; d'ici là, ces mois ne sont sur aucun relevé (ni versés ni perdus) et iront sur le prochain relevé une fois le partage enregistré.",
    edit: "Modifier les étapes",
    save: "Enregistrer",
    cancel: "Annuler",
    saved: "Étapes de la vente enregistrées",
    locked: "Seul un administrateur peut changer les étapes de la vente.",
    fields: {
      demo_by: "Démo par",
      source: "Source de la vente",
      appointment_at: "Rendez-vous pris le",
      override_pct: "Dérogation : part du Closer (%)",
      override_setter_pct: "Dérogation : part du setter (%)",
      override_note: "Raison de la dérogation",
    },
    errors: {
      pct: "Entrez un pourcentage entre 0 et 100.",
      date: "Date invalide.",
      long: "Texte trop long.",
      needs_closer: "Entrez d'abord la part du Closer.",
      sum: "Ensemble, les parts du Closer et du setter ne peuvent dépasser 100 %.",
    },
    refusals: {
      sale_steps_admin_only:
        "Seul un administrateur peut changer les étapes de la vente (%{detail}).",
      invalid_role_holder:
        "Ce rôle doit être confié à un utilisateur actif (%{detail}).",
    },
    roles: { account_manager: "Responsable de compte", referrer: "Apporteur" },
  },
  won_prompt: {
    text: "Opportunité gagnée : créez l'abonnement du client (forfait, options, facturation, premier mois payé).",
    create: "Créer l'abonnement",
  },
};
